import jmaFormValidation from './jma-form-validation'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import eventBus from './event-bus';

const files = require.context('./', true, /\.vue$/i);

files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

const vue = new Vue({
    el: '#app',
});

jQuery(document).ready(function ($) {
    $('.datepicker').datepicker();
    jmaFormValidation();
    $('input.phone').mask('000-000-0000');
});
